export class QuickShop extends ModalOpener {
  
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      this.renderSection()
    });
  }

  renderSection() {
    fetch(this.dataset.url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const pdpForm = html.querySelector('.product-section');
      if (pdpForm && pdpForm.innerHTML.trim().length) {
        const target = document.querySelector(`${this.getAttribute('data-modal')}-Render`)
        target.innerHTML = pdpForm.innerHTML;
      }
    })
    .catch(e => {
      console.error(e);
    });
  }

}

customElements.define('quick-shop', QuickShop)